import Backbone from 'backbone'
import _ from 'lodash'
import context from './initiatives-context'
import tabs from '../initiatives-tabs.hbs'
import InitiativesDisplayHeader from '../initiatives-display-header'
import template from './initiatives-overview.hbs'
import Basics from './basics'
import Schedule from './schedule'
import Budget from './budget'
import Historical from './historical'
import InitiativeArchiveActions from '../initiatives-archive-actions'
import Related from 'scoreboard/related-items/related-items-list'
import NotesLayout from 'scoreboard/notes/notes-layout'
import SendToOptions from 'scoreboard/components/send-to-options'
import conductor from 'scoreboard/components/conductor'
var children = [ 'basics', 'schedule', 'budget', 'historical', 'related', 'archiveActions' ]
import ImportOptions from 'scoreboard/components/import-options'

/**
 * this.model is an Initiative
 */
var InitiativesOverview = Backbone.View.extend({

	className: 'display-layout initiatives-overview',

	/**
	 *
	 * @param {String} [options.mode='graph'] 'graph' or 'table'
	 * @param {Number} [options.noteId] If provided, the note will be displayed
	 * @param {Boolean} [options.newNote=false]
	 */
	initialize: function(options = {}) {
		this.options = options
		this.fullContext = context(this.model)

		const {mode} = this.options
		this.header = new InitiativesDisplayHeader({
			model: this.model,
			subsection: 'overview',
			sendToOptions: SendToOptions.default({section: 'initiatives'}),
			importOptions: ImportOptions.forInitiativeItem(this.model),
			// #7858 #11601 new initiatives don't have this.model.id populated,
			// but they have the overview tab disabled elsewhere
			tabs: tabs({
				id: this.model.id,
				section: 'initiatives',
				// Needed for bookmarks to work (see display-header.js#spectate), #18033
				mode: mode === 'table' ? '/table' : ''
			})
		})
		this.notesLayout = new NotesLayout({
			model: this.model,
			noPeriodDisplay: true
		})
		var options = { model: this.model, fullContext: this.fullContext}
		this.basics = new Basics(options)
		this.schedule = new Schedule({ model: this.model })
		this.budget = new Budget(options)
		this.historical = new Historical({ model: this.model, mode, header: this.header })
		this.related = new Related({ model: this.model })

		this.on('resize', () => {
			this.historical.trigger('resize')
			this.basics.trigger('resize')
			this.notesLayout.resize()
		})

		this.model.on('save:status remove:status', () => {
			this.fullContext = context(this.model)

			// rerender the budget, schedule, costs, but the historical
			// table will take care of itself
			this.renderChildren({ exclude: 'historical' })
		})
		// #28518 after an initiative status import completes, reload
		// #29428 listen to event from importOptions
		this.model.on('import-complete', () => {
			conductor.reload()
		})
	},

	render: function() {
		this.fullContext = context(this.model)

		this.$el.empty().append(this.notesLayout.el)
		this.notesLayout.render()
		this.notesLayout.$el.prepend(this.header.el)
		this.header.render()

		this.$('.scroll-container').append(template(this.context()))

		this.archiveActions = new InitiativeArchiveActions({
			el: this.$('.banner-archive'),
			model: this.model
		})

		this.renderChildren()
		this.secure()

		this.notesLayout.resize()
		this.notesLayout.displayNote({
			id: this.options.noteId,
			noteAction: this.options.newNote ? 'new' : 'view'
		})

		this.$('.scroll-container').on('scroll', () => {
			this.historical.removeTooltips()
		})

		// Re-bind notesLayout events after status save/edit/remove #18217
		this.notesLayout.delegateEvents()

		return this
	},

	renderChildren: function(opts = {}) {
		let childrenToUpdate = opts.exclude ?
			_.filter(children, c => !opts.exclude.includes(c)) :
			children
		_.each(childrenToUpdate, function(child) {
			this.$('.' + child).empty().append(this[child].el)
			_.set(this[child], 'options.fullContext', this.fullContext)
			this[child].render()
		}.bind(this))
	},

	context: function() {
		return _.extend({}, this.model.attributes, {
			totalBudget: this.fullContext.value('initiatives.budget'),
			hasBasicInfo: this.fullContext.hasBasicInfo,
			hasSchedule: this.fullContext.hasSchedule
		})
	},

	secure: function() {
		this.header.conditionallyHideEditTab(this.model.isEditable())
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.notesLayout], 'remove')
		_.each(children, function(child) {
			this[child].remove()
		}.bind(this))
	}

})

InitiativesOverview.loadOptions = {
	relatedItems: true,
	notes: true,
	history: true
}

export default InitiativesOverview

InitiativesOverview.__filename__ = 'initiatives/overview/initiatives-overview.js'
